module.exports = __webpack_public_path__ + "img/photo-0085.8ed28bd5.jpg";